.section {
  padding: 3.5rem 0 4.5rem;
}

.container {
  max-width: 72rem;
  margin: 0 auto;
  padding: 0 1rem;
}

@media (min-width: 640px) {
  .container { padding: 0 1.5rem; }
}

.heading {
  margin: 0 0 1.5rem;
  font-size: clamp(1.65rem, 4vw, 2.25rem);
  font-weight: 740;
  letter-spacing: -0.035em;
  color: var(--zen-text-primary);
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  overflow: hidden;
  border: 1px solid var(--zen-border);
  border-radius: 16px;
  background: var(--zen-bg-surface);
}

.card {
  min-height: 215px;
  padding: 1.65rem;
  border-right: 1px solid var(--zen-border);
  border-bottom: 1px solid var(--zen-border);
  transition: background-color 0.16s ease;
}

.card:hover {
  background: var(--zen-bg-elevated);
}

.card:nth-child(3n) { border-right: 0; }
.card:nth-child(n + 10) { border-bottom: 0; }

.number {
  color: var(--zen-teal-strong);
  font: 700 0.7rem/1 ui-monospace, 'SFMono-Regular', Menlo, monospace;
  letter-spacing: 0.06em;
}

.cardTitle {
  margin: 1.55rem 0 0.65rem;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--zen-text-primary);
}

.cardDesc {
  font-size: 0.875rem;
  line-height: 1.625;
  color: var(--zen-text-secondary);
}

.comingSoon {
  display: flex;
  grid-column: span 2;
  min-height: 215px;
  flex-direction: column;
  justify-content: space-between;
  padding: 1.65rem;
  background: var(--zen-bg-elevated);
}

.comingSoonText {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.6;
  font-weight: 600;
  color: var(--zen-text-muted);
}

@media (max-width: 900px) {
  .grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .card:nth-child(3n) { border-right: 1px solid var(--zen-border); }
  .card:nth-child(2n) { border-right: 0; }
  .card:nth-child(n + 10) { border-bottom: 1px solid var(--zen-border); }
  .comingSoon { border-bottom: 0; }
}

@media (max-width: 600px) {
  .section { padding: 2.75rem 0 3.5rem; }
  .grid { grid-template-columns: 1fr; }
  .card,
  .card:nth-child(3n) { min-height: 0; border-right: 0; border-bottom: 1px solid var(--zen-border); }
  .comingSoon { grid-column: auto; min-height: 150px; }
}
